import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { TableModule } from "primeng/table";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { Dialog } from 'primeng/dialog';
import { StorageService } from "app/modules/shared/services/storage.service";
import { AppSettings } from "app/modules/shared/app.settings";
import { CommonBindingDataService } from "app/modules/shared/services/common-binding-data.service";
import { RestApiService } from "app/modules/shared/services/rest-api.service";

@Component({
  standalone: true,
  selector: 'app-tenant-config',
  templateUrl: './tenant-config.component.html',
  styleUrl: './tenant-config.component.scss',
  imports: [TableModule, CommonModule, ReactiveFormsModule, ButtonModule, Dialog, SelectModule],
})

export class TenantConfigComponent {
  private readonly configKeyPattern = /^[a-z]+(?:_[a-z0-9]+)*$/;

  configData: any[] = [];
  filteredConfigData: any[] = [];
  labelKey: any;
  labelValue: any;
  labelAction: any;
  adminDetails: any;
  isSuperAdmin: boolean = false;
  searchTenantConfigForm: UntypedFormGroup;
  visible: boolean = false;
  tenantConfigForm: UntypedFormGroup;
  isEdit: boolean = false;
  submitting: boolean = false;
  totalRecords:any = 0;

  configCode: any[] | undefined;
  formGroup: FormGroup;
  code: string = 'TNT';
  codeString = 'Tenant';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private commonBindingDataService: CommonBindingDataService,
    private storageService: StorageService,
    private restApiService: RestApiService
  ) { }

  ngOnInit(): void {
    this.adminDetails = this.storageService.getItem(AppSettings.USER_DETAILS);

    if (this.adminDetails.roleId === AppSettings.SYSTEM_ADMIN) {
      this.validate();

      this.searchTenantConfigForm = this.formBuilder.group({
        searchConfigData: ['', []],
      });
      this.formGroup = this.formBuilder.group({
        selectedConfig: ['TNT']
      });

      this.labelKey = this.commonBindingDataService.getLabel('label_Key');
      this.labelValue = this.commonBindingDataService.getLabel('label_Value');
      this.labelAction = this.commonBindingDataService.getLabel('label_action');

      this.isSuperAdmin = true;
      this.loadConfigData("TNT");
    }

    this.configCode = [
      { name: 'Tenant', code: 'TNT' },
      { name: 'System', code: 'SYS' },
    ];


  }

  onSelectConfigCode(event: any) {
    this.loadConfigData(event.value)
  }

  loadConfigData(type: string) {
    this.code = type;
    this.code === 'TNT' ? this.codeString = 'Tenant' : this.codeString = 'System';
    const request$ =
      type === 'SYS'
        ? this.commonBindingDataService.getSystemConfigData()
        : this.commonBindingDataService.getTenantConfigData();

    request$.subscribe({
      next: (res: any) => {
        this.configData = res;
        this.filteredConfigData = [...res];
        this.totalRecords = res.length ? res.length : 0;        
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  validate() {
    this.tenantConfigForm = this.formBuilder.group({
      configKey: ['', [Validators.required, Validators.pattern(this.configKeyPattern)]],
      configValue: ['', Validators.required]
    });
  }

  searchDriver() {
    const searchData = (this.searchTenantConfigForm.controls.searchConfigData.value || '').toLowerCase().trim();

    if (!searchData) {
      this.filteredConfigData = [...this.configData];
      return;
    }

    this.filteredConfigData = this.configData.filter((config) => {
      const configKey = (config?.configKey || '').toLowerCase();
      const configValue = (config?.configValue || '').toLowerCase();
      return configKey.includes(searchData) || configValue.includes(searchData);
    });
  }

  showDialog(config?: any, isEdit = false) {
    this.isEdit = isEdit;
    this.tenantConfigForm.reset();
    this.tenantConfigForm.controls.configKey.enable();

    if (isEdit && config) {
      this.tenantConfigForm.patchValue({
        configKey: config.configKey,
        configValue: config.configValue
      });
      this.tenantConfigForm.controls.configKey.disable();
    }

    this.visible = true;
  }

  saveTenantConfig(tenantCode: string): void {

    if (this.tenantConfigForm.invalid || this.submitting) {
      this.tenantConfigForm.markAllAsTouched();
      return;
    }

    this.submitting = true;
    const formValue = this.tenantConfigForm.getRawValue();
    const payload = {
      configKey: (formValue.configKey || '').trim(),
      configValue: (formValue.configValue || '').trim()
    };

    this.code === 'TNT' ? this.codeString = 'Tenant' : this.codeString = 'System';
    const request$ =
      this.code === 'TNT'
        ? this.restApiService.post('/tenants/config-key', payload, 'page-center')
        : this.restApiService.postSys('system/tenants/config-key', payload, 'page-center')

    request$.subscribe({
      next: () => {
        this.commonBindingDataService.showMessage('Success',
          this.isEdit ? `${this.codeString} config updated successfully` : `${this.codeString} config added successfully`
        );
        this.submitting = false;
        this.visible = false;
        this.loadConfigData(tenantCode);
      },
      error: (error) => {
        this.submitting = false;
        this.commonBindingDataService.showMessage(
          'Error',
          error?.error?.message || 'Failed to save config Data'
        );
      }
    });
  }
}
